import { render, staticRenderFns } from "./LATIcon.vue?vue&type=template&id=1c0c9d0e&scoped=true&"
import script from "./LATIcon.vue?vue&type=script&lang=js&"
export * from "./LATIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0c9d0e",
  null
  
)

export default component.exports